export const enum StatusTypes {
  ENABLED = "Enabled",
  DISABLED = "Disabled",
}


